/** Allowlisted moderator who can start walk-in manual charging. */
export const MANUAL_CHARGE_ALLOWED_MODERATOR_EMAIL = 'csmbanak@albmove.al';

// Same person may exist in both `users` and `staff_users` with different IDs.
// Login uses staff_users first, so we accept either ID + the email.
export const MANUAL_CHARGE_ALLOWED_MODERATOR_IDS = [
  '2e047596-0534-42d5-b7bb-864aeb847c86', // staff_users (login source of truth)
  '9d80a1a4-7af1-47ae-97af-b06c3bea2bda', // legacy users collection
];

/** Fixed client that all walk-in manual charges are billed to. */
export const MANUAL_CHARGE_FIXED_CLIENT_ID = '57af5339-8ec0-4068-9e61-0188ce1b000d';
export const MANUAL_CHARGE_FIXED_CLIENT_EMAIL = 'csmbanak@gmail.com';

export function canUseModeratorManualCharge(user) {
  if (!user) return false;
  const id = String(user.id || '').trim();
  const email = String(user.email || '').trim().toLowerCase();
  const role = String(user.role || '').trim().toUpperCase();
  const roleOk = role === 'MODERATOR' || role === 'ADMIN' || role === 'SUPER_ADMIN';
  if (!roleOk) return false;
  // Email is the primary gate; IDs cover both staff_users and users records.
  if (email === MANUAL_CHARGE_ALLOWED_MODERATOR_EMAIL.toLowerCase()) return true;
  return MANUAL_CHARGE_ALLOWED_MODERATOR_IDS.includes(id);
}
